import * as React from "react";
import { useInstantSearch, useHits } from "react-instantsearch";
import { dispatchTrackErrorEvent } from "@grandvisionhq/svc-tealium/events";
import { useAlgoliaConfig } from "../../../Algolia/AlgoliaConfig.js";
import { useAlgoliaIndex } from "./use-algolia-index.js";
function useAlgoliaData() {
  const { priceSegmentCookie } = useAlgoliaConfig();
  const {
    results: { query, nbHits, renderingContent },
    indexUiState,
    uiState,
    status,
    setIndexUiState
  } = useInstantSearch();
  const { items } = useHits();
  if (status === "error") {
    dispatchTrackErrorEvent(
      () => Promise.resolve({
        Error_Source: "Server",
        Error_Code: "Search",
        Error_Details: "Unable to search for products",
        Error_Message: ""
      })
    );
  }
  const productType = indexUiState.refinementList?.["filterableAttributes.productType"]?.[0] ?? indexUiState.refinementList?.productType?.[0];
  const mappedResults = useAlgoliaIndex(
    items,
    query.length > 0 ? void 0 : productType,
    priceSegmentCookie
  );
  const value = React.useMemo(
    () => ({
      allSearchResults: uiState,
      facetOrder: renderingContent?.facetOrdering?.facets?.order ?? [],
      mappedResults,
      searchQuery: query,
      searchState: indexUiState,
      total: nbHits,
      isLoading: status === "loading",
      setIndexUiState
    }),
    [
      indexUiState,
      mappedResults,
      nbHits,
      query,
      renderingContent?.facetOrdering?.facets?.order,
      setIndexUiState,
      status,
      uiState
    ]
  );
  return value;
}
export {
  useAlgoliaData
};
//# sourceMappingURL=use-algolia-data.js.map
